"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("../../../shared/uikit/Button"));

require("./SearchAutopilot.scss");

var _Refresh = _interopRequireDefault(require("@insided/destination/icons/Refresh"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ErrorState = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ErrorState, _PureComponent);

  var _super = _createSuper(ErrorState);

  function ErrorState() {
    (0, _classCallCheck2.default)(this, ErrorState);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ErrorState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errorMessage = _this$props.errorMessage,
          onRetry = _this$props.onRetry;
      return (0, _preact.h)("div", {
        className: "reload-page-container"
      }, (0, _preact.h)("div", {
        className: "reload-page-content"
      }, (0, _preact.h)("div", {
        className: "error-message"
      }, errorMessage), (0, _preact.h)(_Button.default, {
        variant: "secondary",
        outlined: true,
        startIcon: (0, _preact.h)(_Refresh.default, {
          width: 16,
          height: 16
        }),
        onClick: onRetry,
        className: "retry-button"
      }, "Retry")));
    }
  }]);
  return ErrorState;
}(_preactCompat.PureComponent);

exports.default = ErrorState;